import React from "react";
import globalVars from "../utils/globalVars";

export default function DefaultComponent(props) {
    // ### ? ###
    // OBLIGATORY_KEYS = ['id', 'meta', 'source', 'type']
    // STD_KEYS = ['hint', 'sentence', 'subtitle', 'title']

    return (
        <div key={props.index}>
            <p style={{backgroundColor: globalVars.feedbackMode.backgroundColor.notOk}}>Typ noch nicht definiert!</p>
            <pre>exercise = {JSON.stringify(props.exercise, null, 2)}</pre>
        </div>
    );
}
